import React from 'react';

/** Typographic stand-in for the Ferring logo — replace with the official Ferring SVG asset. */
export function FerringWordmark({
  className = ''
}: {
  className?: string;
}) {
  return <span className={`inline-flex flex-col leading-none ${className}`} aria-label="Ferring Pharmaceuticals" data-id="element-131" data-mp="3lrobegnt0rv6">
      <span className="text-[17px] font-semibold tracking-[0.18em] text-ferring" data-id="element-132" data-mp="3h0ocj5v4jzq1">FERRING</span>
      <span className="mt-1 text-[7px] font-medium tracking-[0.42em] text-ferring/80" data-id="element-133" data-mp="3us37mb2b3rdg">PHARMACEUTICALS</span>
    </span>;
}